import globals from '@/utils/globals';
import {
	BestFitAPIClient,
	BestFitEnvironment,
	SessionServiceFetchRequestJWTSigner,
	BestFitResult,
} from '@studyportals/bestfit-api-fe-client';
import { ScoreDeterminantType } from '@studyportals/bestfit-api-fe-client';

declare const ENVIRONMENT: string;

export class BestFitRepository {
	private bestFitAPIClient: BestFitAPIClient;
	private environment?: string;

	constructor() {
		this.setEnvironment();
		const jwtSigner = new SessionServiceFetchRequestJWTSigner(
			globals.sessionService,
		);

		this.bestFitAPIClient = new BestFitAPIClient(this.getStage(), jwtSigner);
	}

	public async combinedCalculation(
		studyIds: number[],
		scoreDeterminantTypes: ScoreDeterminantType[],
		experimentVariation?: number,
	): Promise<Map<number, Map<ScoreDeterminantType, BestFitResult>>> {
		return this.bestFitAPIClient.getCombinedResult(
			studyIds,
			scoreDeterminantTypes,
			experimentVariation,
		);
	}

	private setEnvironment(): void {
		try {
			this.environment = ENVIRONMENT;
		} catch {
			this.environment = undefined;
		}
	}

	private getStage(): BestFitEnvironment {
		const stage = this.environment;
		return stage ? (stage as BestFitEnvironment) : BestFitEnvironment.TESTING;
	}
}
